/* global google */
import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { SearchBox } from 'react-google-maps/lib/components/places/SearchBox';

import { CircularProgress, Card, CardText, TextField } from 'material-ui';

import { get } from 'lodash';

const MapWithAMarker = withScriptjs(withGoogleMap((props) => (
  <GoogleMap
    ref={props.bindMap}
    defaultZoom={17}
    center={props.coords}
  >
    <SearchBox
      ref={props.bindSearch}
      controlPosition={2}
      onPlacesChanged={props.onPlacesChanged}
    >
      <Card style={{ opacity: '0.86' }}>
        <CardText>
          <TextField placeholder="Search address" />
        </CardText>
      </Card>
    </SearchBox>
    <Marker
      position={props.coords}
      draggable
      onDragEnd={props.onDragEnd}
    />
  </GoogleMap>
)));

export class CoordinateInput extends Component {
  constructor(props) {
    super(props);
    const { input: { value } } = props;
    this.state = {
      coords: { lat: value[0] || 57.9750135, lng: value[1] || 11.7008235 },
    };
  }

  onDragEnd = (data) => this.props.input.onChange([data.latLng.lat(), data.latLng.lng()]);

  onPlacesChanged = () => {
    const places = this.search.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    const nextMarkers = places.map((place) => ({
      position: place.geometry.location,
    }));
    const nextCoords = get(nextMarkers, '0.position', this.state.coords);

    this.onDragEnd({ latLng: nextCoords });
    this.setState({
      coords: nextCoords,
    });
  }

  render = () => (
    <MapWithAMarker
      bindMap={(map) => { this.map = map; }}
      bindSearch={(search) => { this.search = search; }}
      onPlacesChanged={this.onPlacesChanged}
      onDragEnd={this.onDragEnd}
      coords={this.state.coords}
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAoVTD-bu5chUOe_lAMrXktdaR8mQf0YF4&v=3.exp&libraries=geometry,drawing,places"
      loadingElement={<div style={{ height: '100%' }}><CircularProgress id="map-progress" /></div>}
      containerElement={<div style={{ height: '400px' }} />}
      mapElement={<div style={{ height: '100%' }} />}
    />
  );
}

CoordinateInput.defaultProps = {
  addField: true,
};

export default CoordinateInput;
